<button
  type="button"
  class="premium-pill-toggle"
  (click)="theme.toggleTheme()"
  [attr.aria-label]="theme.toggleLabelKey() | translate"
>
  <div class="toggle-icon">
    <i class="pi" [class.pi-sun]="theme.isDarkMode()" [class.pi-moon]="!theme.isDarkMode()"></i>
  </div>
  <span class="toggle-label">{{ theme.targetThemeModeKey() | translate }}</span>
</button>
